import {
  IDLE_ACTIVE_KEY,
  IDLE_LAST_ACTIVITY_KEY,
  IDLE_RETURN_PATH_KEY,
} from '@/constants/idle';

const safeSession = {
  get(key: string): string | null {
    if (typeof window === 'undefined') return null;
    try {
      return sessionStorage.getItem(key);
    } catch {
      return null;
    }
  },
  set(key: string, value: string): void {
    if (typeof window === 'undefined') return;
    try {
      sessionStorage.setItem(key, value);
    } catch {
      // ignore
    }
  },
  remove(key: string): void {
    if (typeof window === 'undefined') return;
    try {
      sessionStorage.removeItem(key);
    } catch {
      // ignore
    }
  },
};

export function isAppIdleActive(): boolean {
  return safeSession.get(IDLE_ACTIVE_KEY) === '1';
}

export function setAppIdleActive(active: boolean): void {
  if (active) {
    safeSession.set(IDLE_ACTIVE_KEY, '1');
  } else {
    safeSession.remove(IDLE_ACTIVE_KEY);
  }
}

export function getIdleReturnPath(): string | null {
  const path = safeSession.get(IDLE_RETURN_PATH_KEY);
  if (!path || path.startsWith('/idle')) return null;
  return path;
}

export function setIdleReturnPath(path: string): void {
  if (!path || path.startsWith('/idle')) return;
  safeSession.set(IDLE_RETURN_PATH_KEY, path);
}

export function clearIdleReturnPath(): void {
  safeSession.remove(IDLE_RETURN_PATH_KEY);
}

export function getLastActivityAt(): number {
  const raw = safeSession.get(IDLE_LAST_ACTIVITY_KEY);
  const parsed = raw ? Number.parseInt(raw, 10) : NaN;
  return Number.isFinite(parsed) ? parsed : Date.now();
}

export function touchLastActivity(at = Date.now()): void {
  safeSession.set(IDLE_LAST_ACTIVITY_KEY, String(at));
}

export function clearIdleSession(): void {
  safeSession.remove(IDLE_ACTIVE_KEY);
  safeSession.remove(IDLE_RETURN_PATH_KEY);
  safeSession.remove(IDLE_LAST_ACTIVITY_KEY);
}

export function getIdleElapsedMs(): number {
  return Date.now() - getLastActivityAt();
}
